import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Output } from '@angular/core';

const stepsA = Array.from({ length: 9 }, (_, i) => (i + 1) * 10); // 10-90
const stepsB = Array.from({ length: 10 }, (_, i) => (i + 1) * 100); // 100-1000
const steps = [...stepsA, ...stepsB];

@Component({
  selector: 'tx-zoom-slider',
  templateUrl: './zoom-slider.component.html',
  styleUrls: ['./zoom-slider.component.scss'],
})
export class ZoomSliderComponent {
  @Output() onZoomUpdate = new EventEmitter<number | string>();

  value: number = 100;
  options: Options = {
    stepsArray: steps.map((value) => ({
      value,
    })),
    showTicksValues: false,
    ticksArray: [9],
  };

  onUserChange(changeContext: ChangeContext) {
    this.setZoomFactor(changeContext.value);
  }

  private setZoomFactor(value: number) {
    this.onZoomUpdate.emit(value);
  }

  zoomIn() {
    const newIndex = this.findCurrentIndex() + 1;
    this.value = steps[newIndex] || 100;
    this.setZoomFactor(this.value);
    return false;
  }

  zoomOut() {
    const newIndex = this.findCurrentIndex() - 1;
    this.value = steps[newIndex] || 100;
    this.setZoomFactor(this.value);
    return false;
  }

  zoomPreset(preset: string) {
    this.onZoomUpdate.emit(preset);
    return false;
  }

  findCurrentIndex() {
    return steps.findIndex((step) => step === this.value);
  }
}


